import React, { useState, useEffect } from 'react'
import './ShippingLabelVerificationModal.css'
import { Modal, Header, Input } from 'semantic-ui-react'


const ShippingLabelVerificationModal = ({ open, verify }) => {
  const [input, setInputState] = useState("");
  const [isLoading, setisLoadingState] = useState(false);

  useEffect(() => {
    focusInput();
  })

  const inputRef = React.createRef()
  
  const focusInput = () => {
    if (open && inputRef && inputRef.current) {
      inputRef.current.focus()
    }
  }

  const setInputValue = (ev) => {
    setInputState(ev.target.value)
  }

  const onInputKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      setisLoadingState(true);
      verify(input)
      setTimeout(() => {
        setInputState("");
        setisLoadingState(false);
      }, 300)
    }
  }

  const onInputBlur = () => {
    focusInput()
  }

  return (
    <Modal
      open={open}
      size="small"
      className="ShippingLabelVerificationModal"
    >
      <Header icon='warning sign' color="red" content={"SKANNA FRAKTETIKETT"} />
      <Modal.Content>
        <div className="InputContainer">
          <Input
            className="InputElement"
            autoFocus
            autoComplete="off"
            ref={inputRef}
            value={input}
            placeholder={"Fraktetikett"}
            loading={isLoading}
            onChange={(ev) => setInputValue(ev)}
            onBlur={() => onInputBlur()}
            onKeyPress={(ev) => onInputKeyPress(ev)} />
        </div>
      </Modal.Content>
      {/* <Modal.Actions>
              <Button primary onClick={onClose}>
                OKEJ
              </Button>
            </Modal.Actions> */}
    </Modal>
  )
}

export default ShippingLabelVerificationModal;
